import gql from 'graphql-tag'
import { CONVERSATION_FRAGMENT, MESSAGE_FRAGMENT } from './Queries'

export const MessagingSendMessageMutation = gql`
  mutation messagingSendMessage($conversationId: ID!, $body: String!, $bodyHtml: String, $files: [FileInput!], $scheduledForTimestamp: Int) {
    messagingSendMessage(
      conversationId: $conversationId,
      body: $body,
      bodyHtml: $bodyHtml,
      files: $files,
      scheduledForTimestamp: $scheduledForTimestamp
    ) {
      message {
        id
      }
      ok
      errors
    }
  }
`;

export const CREATE_CONVERSATION = gql`
  mutation CreateConversation($to: String!, $body: String!, $channelId: ID!, $inboxId: ID, $subject: String) {
    messagingCreateConversation(to: $to, body: $body, channelId: $channelId, inboxId: $inboxId, subject: $subject) {
      ok
      conversation {
        ...ConversationFields
      }
      message {
        ...MessageFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
  ${MESSAGE_FRAGMENT}
`;

export const ASSIGN_CONVERSATION = gql`
  mutation AssignConversation($conversationId: ID!, $userId: ID!) {
    messagingAssignConversation(conversationId: $conversationId, userId: $userId) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const UPDATE_CONVERSATION_STATUS = gql`
  mutation UpdateConversationStatus($conversationId: ID!, $status: String!) {
    messagingUpdateConversationStatus(conversationId: $conversationId, status: $status) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const ADD_CONVERSATION_TAG = gql`
  mutation AddConversationTag($conversationId: ID!, $tagName: String!) {
    messagingAddConversationTag(conversationId: $conversationId, tagName: $tagName) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const REMOVE_CONVERSATION_TAG = gql`
  mutation RemoveConversationTag($conversationId: ID!, $tagName: String!) {
    messagingRemoveConversationTag(conversationId: $conversationId, tagName: $tagName) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const STAR_CONVERSATION = gql`
  mutation StarConversation($conversationId: ID!) {
    messagingStarConversation(conversationId: $conversationId) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const UNSTAR_CONVERSATION = gql`
  mutation UnstarConversation($conversationId: ID!) {
    messagingUnstarConversation(conversationId: $conversationId) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const SUBSCRIBE_CONVERSATION = gql`
  mutation SubscribeConversation($conversationId: ID!, $userId: ID) {
    messagingSubscribeConversation(conversationId: $conversationId, userId: $userId) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const UNSUBSCRIBE_CONVERSATION = gql`
  mutation UnsubscribeConversation($conversationId: ID!, $userId: ID) {
    messagingUnsubscribeConversation(conversationId: $conversationId, userId: $userId) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const MARK_CONVERSATION_READ = gql`
  mutation MarkConversationRead($conversationId: ID!) {
    messagingMarkAssignedConversationRead(conversationId: $conversationId) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;


export const UPDATE_CONVERSATION = gql`
  mutation UpdateConversation(
    $conversationId: ID!,
    $status: String,
    $subject: String,
    $isReadByAssignedAgent: Boolean,
    $contactName: String,
    $driverId: ID,
    $assignedToId: ID,
    $subscriberIds: [ID!],
    $inboxIds: [ID!],
  ) {
    messagingUpdateConversation(
      conversationId: $conversationId,
      status: $status,
      subject: $subject,
      isReadByAssignedAgent: $isReadByAssignedAgent,
      contactName: $contactName,
      driverId: $driverId,
      assignedToId: $assignedToId,
      subscriberIds: $subscriberIds,
      inboxIds: $inboxIds,
    ) {
      ok
      conversation {
        ...ConversationFields
      }
      errors
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const CREATE_CONVERSATION_NOTE = gql`
  mutation CreateConversationNote($conversationId: ID!, $note: String!) {
    messagingCreateConversationNote(conversationId: $conversationId, note: $note) {
      ok
      errors
    }
  }
`;
